import { Row, Col, DatePicker } from "antd";
import React from "react";

interface DatePickersProps {
  filterDates: boolean;
  saleDateStart: moment.Moment | undefined;
  saleDateEnd: moment.Moment | undefined;
  saleEffectiveDateStart: moment.Moment | undefined;
  saleEffectiveDateEnd: moment.Moment | undefined;
  setSaleDateStart: (date: moment.Moment | undefined) => void;
  setSaleDateEnd: (date: moment.Moment | undefined) => void;
  setSaleEffectiveDateStart: (date: moment.Moment | undefined) => void;
  setSaleEffectiveDateEnd: (date: moment.Moment | undefined) => void;
}

interface DateRangePickerProps {
  label: string;
  filterDates: boolean;
  startDate: moment.Moment | undefined;
  endDate: moment.Moment | undefined;
  setStartDate: (date: moment.Moment | undefined) => void;
  setEndDate: (date: moment.Moment | undefined) => void;
}

export function DateRangePicker({
  label,
  filterDates,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: DateRangePickerProps) {
  return (
    <Col span={24}>
      <div style={{ marginBottom: "8px", fontWeight: "bold" }}>{label}</div>
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <div style={{ marginBottom: "4px" }}>Start Date</div>
          <DatePicker
            style={{ width: "100%" }}
            placeholder="Start Date"
            disabled={!filterDates}
            value={startDate}
            onChange={(date) => setStartDate(date || undefined)}
          />
        </Col>
        <Col span={24}>
          <div style={{ marginBottom: "4px" }}>End Date</div>
          <DatePicker
            style={{ width: "100%" }}
            placeholder="End Date"
            disabled={!filterDates}
            value={endDate}
            onChange={(date) => setEndDate(date || undefined)}
          />
        </Col>
      </Row>
    </Col>
  );
}

export function SaleDatePickers(props: DatePickersProps) {
  const {
    filterDates,
    saleDateStart,
    saleDateEnd,
    saleEffectiveDateStart,
    saleEffectiveDateEnd,
    setSaleDateStart,
    setSaleDateEnd,
    setSaleEffectiveDateStart,
    setSaleEffectiveDateEnd,
  } = props;

  return (
    <Row align="middle" justify="center" style={{ paddingBottom: "10px" }}>
      <Col span={24}>
        <Row gutter={[0, 8]}>
          <DateRangePicker
            label="Sale Date Range"
            filterDates={filterDates}
            startDate={saleDateStart}
            endDate={saleDateEnd}
            setStartDate={setSaleDateStart}
            setEndDate={setSaleDateEnd}
          />
          <Col span={24} style={{ marginTop: "12px" }}>
            <DateRangePicker
              label="Sale Effective Date Range"
              filterDates={filterDates}
              startDate={saleEffectiveDateStart}
              endDate={saleEffectiveDateEnd}
              setStartDate={setSaleEffectiveDateStart}
              setEndDate={setSaleEffectiveDateEnd}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
